import { Component } from "react";
import ProfileServices from "../../Services/ProfileServices";
import { loadFromLocalStorage } from "../../Common/Validation/LocalStorage";
import { TableColumn } from "react-data-table-component";
import DataGrid from "../../Components/DataGrid/DataGrid";
import Swal from "sweetalert2";



export interface IPayment {
    paymentId: string;
    paymentIntentId: string;
    paymentStatus: 'Pending' | 'Paid' | 'Initiated' | 'Not Paid' | string;
    amount: number;
    tax: number;
    paidAmount: number;
    createdDate: string;
    subscriptionId: string;
}

interface ISubscriptionsListResponse {
    userId: string
    userName: string;
    email: string;
    mobileNumber: string;
    subscriptionId: string;
    stripeSubscriptionId: string;
    startDate: string;
    endDate: string;
    subscriptionRate: number;
    isSubActive: boolean;
    isMonitoring: boolean;
    payments: IPayment[];
}

interface ISubscriptionsListState {
    subList: ISubscriptionsListResponse[]
    accessToken: string,
    currentPage: number,
    currentRowsPerPage: number,
    searchText: string,
    totalRows: 0,
    currentSortColumn: string,
    sortingDirection: string
}

interface IpaymentProps {
    payments: IPayment[];
}

// Payment child table
class PaymentTable extends Component<IpaymentProps, {}> {
    constructor(props: IpaymentProps) {
        super(props);
    }

    private paymentColumns: TableColumn<IPayment>[] = [
        { name: 'Payment Intent ID', selector: row => row.paymentIntentId, minWidth:'150px' },
        { name: 'Status', selector: row => row.paymentStatus, maxWidth:'150px'  },
        { name: 'Amount', selector: row => `$${row.amount}`, maxWidth:'100px'  },
        { name: 'Tax', selector: row => `$${row.tax}`, maxWidth:'100px'  },
        { name: 'Paid', selector: row => `$${row.paidAmount}`, maxWidth:'100px'  },
        { name: 'Created', selector: row => row.createdDate },
    ];
    render() {
        return (
            <DataGrid
                title='Payment Details'
                columns={this.paymentColumns}
                data={this.props.payments}
                pagination
                paginationTotalRows={this.props.payments?.length}
            />
        );
    }
}


class SubscriptionsList extends Component<{}, ISubscriptionsListState> {

    constructor(_props: any) {
        super(_props);
        this.state = {
            subList: [],
            accessToken: '',
            currentPage: 1,
            currentRowsPerPage: 10,
            searchText: '',
            totalRows: 0,
            currentSortColumn: '',
            sortingDirection: ''
        }
    }

    private formColumns: TableColumn<ISubscriptionsListResponse>[] = [
        {
            name: 'Subscription ID',
            selector: (row: ISubscriptionsListResponse) => row.stripeSubscriptionId,
            minWidth: '175px',
            maxWidth: '325px'
        },
        {
            name: 'Taxpayer Name',
            selector: (row: ISubscriptionsListResponse) => row.userName,
            sortable: true,
            maxWidth: '175px'
        },
        {
            name: 'Email',
            selector: (row: ISubscriptionsListResponse) => row.email,
            sortable: true,
            maxWidth: '200px'
        },
        {
            name: 'Start Date',
            selector: (row: ISubscriptionsListResponse) => row.startDate.split('T')[0],
            maxWidth: '120px'
        },
        {
            name: 'End Date',
            selector: (row: ISubscriptionsListResponse) => row.endDate.split('T')[0],
            maxWidth: '120px'
        },
        {
            name: 'Amount',
            cell: (row: ISubscriptionsListResponse) => <span style={{textAlign: 'right',  width: '100%'}}>${Number(row.subscriptionRate).toFixed(2)}</span>,
            maxWidth: '100px',
            minWidth: '80px',
        },
        {
            name: 'Is Monitoring',
            cell: (row: ISubscriptionsListResponse) => <span style={{textAlign: 'center',  width: '100%'}}>{row.isMonitoring ?  'Yes' : 'No'}</span>,
            maxWidth: '100px',
            minWidth: '80px',
        },
        {
            name: 'Is Active',
            cell: (row: ISubscriptionsListResponse) => <span style={{textAlign: 'center',  width: '100%'}}>{row.isSubActive ?  'Yes' : 'No'}</span>,
            maxWidth: '100px',
            minWidth: '80px',
        }
    ];

    async componentDidMount() {
        ///... check token in local storage
        const accesstoken = await loadFromLocalStorage('accessToken');
        ///... if available get user details otherwise re-direct to login page
        if (accesstoken) {
            this.setState({
                accessToken: accesstoken.toString()
            }, () => {
                this.getSubscriptionsList();
            });
        }
        else {
            localStorage.clear();
            window.location.href = '/'
        }
    }



    getSubscriptionsList() {
        let postData = {
            sort: {
                column: this.state.currentSortColumn,
                direction: this.state.sortingDirection
            },
            limit: this.state.currentRowsPerPage,
            offset: (this.state.currentPage - 1) * this.state.currentRowsPerPage,
            searchFilter: this.state.searchText
        };
        ProfileServices.getAllSubscriptionsList(postData, this.state.accessToken).then(r => {
            if (r.ok) {
                r.json().then(response => {
                    this.setState({ subList: response.data, totalRows: response.totalCount });
                })
            }
        });
    }

    refundSubscriptionAmount(row: ISubscriptionsListResponse) {
        let postData = {
            userId: row.userId
        };

        ProfileServices.refundSubscriptionAmount(postData, this.state.accessToken).then(r => {
            if (r.ok) {
                this.getSubscriptionsList();
                r.json().then(response => {
                    Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: `Initiated refund successfully for ${row.userName} successfully`,

                    })
                })
            }
        })
    }

    identifySortingMapColumn(columnName: string) {
        let actualColName = '';
        switch (columnName) {
            case "Taxpayer Name":
                actualColName = 'userName';
                break;
            case "Email":
                actualColName = 'email';
                break;
            case "Mobile Number":
                actualColName = 'mobileNumber';
                break;
        }
        return actualColName;
    }

    public render() {

        const ExpandedComponent = ({ data }: { data: ISubscriptionsListResponse }) => (
            <div style={{ padding: '10px', background: '#f9f9f9' }}>
                <PaymentTable payments={data.payments} />
            </div>
        );
        return (
            <div className='body-sub-contianer table-container'>
                {/* <h1>Transaction Logs</h1> */}
                <DataGrid
                    title='Subscription Details'
                    search='User Details'
                    columns={this.formColumns}
                    data={this.state.subList}
                    onSearch={(searchText_: string) => {
                        this.setState({
                            searchText: searchText_,
                            currentPage: 1
                        }, () => {
                            this.getSubscriptionsList();
                        })
                    }}

                    onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
                        this.setState({
                            currentPage: currentPage,
                            currentRowsPerPage: currentRowsPerPage
                        }, () => {
                            this.getSubscriptionsList();
                        })
                    }}
                    onChangePage={(page: number, totalRows: number) => {
                        console.log(page, totalRows);
                        this.setState({
                            currentPage: page
                        }, () => {
                            this.getSubscriptionsList();
                        })
                    }}
                    onSort={(column: any, direction) => {

                        this.setState({
                            currentSortColumn: this.identifySortingMapColumn(column.name),
                            sortingDirection: direction,
                            currentPage: 1
                        }, () => {
                            this.getSubscriptionsList();
                        })
                    }}
                    expandableRows
                    expandedComponent={ExpandedComponent}
                    pagination
                    paginationTotalRows={this.state.totalRows}
                />
            </div>
        )
    }

}
export default SubscriptionsList;